export default __webpack_public_path__ + "static/1183-979ec47a9d40c2b295d05587acefed0b.gif";